import FilterDiscounts from './filterDiscounts'

export default FilterDiscounts
